import { useState, useMemo } from 'react';

const useSearchInput = (
  searchChangeDataMatcher,
  { data = [], filterClickDataMatcher = () => null },
) => {
  if (!searchChangeDataMatcher) throw new Error('searchChangeDataMatcher function is required');
  if (searchChangeDataMatcher && typeof searchChangeDataMatcher !== 'function') throw new Error('searchChangeDataMatcher must be a valid function');
  if (filterClickDataMatcher && typeof filterClickDataMatcher !== 'function') throw new Error('filterClickDataMatcher must be a valid function');

  const [filteredData, setFilteredData] = useState(data);
  const [isSearchTermEmpty, setIsSearchTermEmpty] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const events = useMemo(() => ({
    handleSearchChange: (e) => {
      setIsLoading(true);

      const value = e.currentTarget.value.trim();
      const hasValue = value.length > 0;

      setSearchTerm(value);
      setIsSearchTermEmpty(!hasValue);

      if (!hasValue) {
        setFilteredData(data);
        setIsLoading(false);
        return;
      }

      const searchData = searchChangeDataMatcher(data, value);

      setFilteredData(searchData);
      setIsLoading(false);
    },
    handleFilterClick: (value) => {
      setIsLoading(true);

      if (value === null) {
        setFilteredData(data);
        setIsLoading(false);
        return;
      }

      const filterData = filterClickDataMatcher(data, value);
      setFilteredData(filterData);

      setIsLoading(false);
    },
  }), [data, filterClickDataMatcher, searchChangeDataMatcher, setIsLoading, setFilteredData]);

  return {
    setIsLoading,
    isLoading,
    searchTerm,
    isSearchTermEmpty,
    filteredData,
    events,
  };
};

export default useSearchInput;
